import Vue from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
import http from './assets/js/request.js'
// 按需导入elementui
// import "./assets/js/element.js"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import {getSiteId} from './assets/js/api'
Vue.use(ElementUI,VueResource)
// 公共样式

import App from './App'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import VueAliplayerV2 from 'vue-aliplayer-v2';

Vue.use(VueAliplayerV2);

import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo)



// Vue.use(VueResource);
import './assets/css/base.less';
// echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.prototype.$http=http

Vue.config.productionTip = false
Vue.filter('dateFormat', function(originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  return `${y}.${m}.${d}`
  // const hh = (dt.getHours() + '').padStart(2, '0')
  // const mm = (dt.getMinutes() + '').padStart(2, '0')
  // const ss = (dt.getSeconds() + '').padStart(2, '0')
  // return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


/**
 * 以下全局守卫迁至router下index.js
 */
// router.beforeEach((to, from, next) => {
//     console.log("222222220000002")
//     // let common = ['login']
//     let host = window.location.host
//     if (to.path == "/login") {
//         // next();
//         // return
//     }else{
//         next();
//         return
//     }
//     console.log("222222222"+host)
//     // this.host = this.host.split(":")[0].split("/")[-1];
//
//     console.log(document.domain)
//     console.log(window.location.host)
//     console.log(window.location.href)
// //smlyzyxy.zjwam.net
//     getSiteId('zyjy').then((res) => {
//         // getSiteId('zyjy').then((res) => {
//         console.log("站点信息")
//         console.log(res);
//         if (res.code == 200) {
//             console.log(res.data.siteId)
//             window.localStorage.setItem('siteId', res.data.siteId)
//         }
//     });
//     console.log("to.path====="+to.path)
//     console.log("to.path=====1"+(to.path == "/login"))
//     next();
//     if (to.path == "/login") {
//         next();
//         return
//     }
// });

